import React from 'react';
import language from '../../../img/Icons/Update/Language.png'
import IconLarge from '../../GeneralSubcomponents/IconLarge'
import '../../../Styles/language.css'

const Language = () => (

    <div className="lan">
        <div className="row o-icon-title"><IconLarge iconL={language} /><p> &nbsp; Languages</p></div>
        <div className="col o-col-lan">
            <div className="row o-language-item">
                <span className="o-len-tittle">Spanish</span>
                <span className="o-language-level">Native Speaker</span>
            </div>
            <div className="row o-language-item">
                <span className="o-len-tittle">English</span>
                <span className="o-language-level">B2</span>
            </div>
        </div>
    </div>

);
export default Language;